export default "__VITE_ASSET__B50bC0AO__"